import defaultDiacriticsRemovalMap from "./defaultDiacriticsRemovalMap";

// Sanitizer: Removes points, unknown characters, apostrophes, spaces and dashes.
export const V23 = (value: string) => {
  let str = value;
  for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
  }
  return str.replace(/[^A-Za-z0-9]/g, "");
};

// Sanitizer: Removes points, unknown characters and apostrophes. Saves spaces and dashes
export const V26 = (value: string) => {
  let str = value;
  for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
  }
  return str.replace(/[^A-Za-z0-9' -]/g, "");
};

// Sanitizer: Removes points and unknown characters. Saves spaces, apostrophe and dashes
export const V27 = (value: string) => {
  let str = value;
  for (let i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
    str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
  }
  return str.replace(/[^A-Za-z0-9 -]/g, "");
};

// Sanitizer: Removes numbers
export const V48 = (value: string) => {
  return value.replace(/[\d]/g, "");
};

// Capitalize each word (separated by either whitespace or hyphen)
export const V58 = (value: string) => {
  return value.toLowerCase().replace(/(^|\s|-)[a-z]/g, function (x) {
    return x.toUpperCase();
  });
};

export const postcodeAddSpaceSanity = (value: string) => value.replace(/^(\d*)([a-zA-Z]{2})/, "$1 $2").toUpperCase();

export const capitalize = (value: string) => value.toUpperCase();
